import script from "./profileTabs.vue?vue&type=script&lang=js"
export * from "./profileTabs.vue?vue&type=script&lang=js"

import "./profileTabs.vue?vue&type=style&index=0&id=0e95ee8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e95ee8a"]])

export default __exports__